var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppotaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 76,
    viewBox: "0 0 128 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1168_18957)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.2277 32.1413C78.4773 32.1413 77.8684 31.5324 77.8684 30.7814C77.8684 30.0304 78.4773 29.4221 79.2277 29.4221C79.9787 29.4221 80.5876 30.0304 80.5876 30.7814C80.5876 31.5324 79.9787 32.1413 79.2277 32.1413ZM79.2277 28.0623C77.7257 28.0623 76.5081 29.2799 76.5081 30.7814C76.5081 32.2837 77.7263 33.5005 79.2277 33.5005H84.1226V28.0623H79.2277Z",
    fill: "url(#paint0_linear_1168_18957)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.228 26.9747H84.1226V16.6412C84.1226 16.0406 83.6353 15.5542 83.0347 15.5542H42.7902V15.5539C42.7902 14.653 43.5203 13.9224 44.422 13.9224H45.9282L48.0993 12.2914H43.8784C42.0758 12.2914 40.6147 13.7516 40.6147 15.5539V15.5542V37.3076V42.7464C40.6147 44.5481 42.0763 46.0092 43.8784 46.0092H80.8587C82.6618 46.0092 84.1226 44.5481 84.1226 42.7464V34.5884H79.228C77.1257 34.5884 75.4212 32.8848 75.4212 30.7814C75.4212 28.6791 77.1257 26.9747 79.228 26.9747Z",
    fill: "url(#paint1_linear_1168_18957)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.1221 12.2914H78.6288L79.1375 13.9224H84.1221C85.0232 13.9224 85.7539 14.653 85.7539 15.5539V26.9747L84.1226 28.0623V33.5006L85.7539 32.413V41.1916C86.7606 40.2044 87.3857 38.8294 87.3857 37.3076V15.5539C87.3857 13.7524 85.9241 12.2914 84.1221 12.2914Z",
    fill: "#55B336"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.7339 14.7386H58.7253L75.6118 7.77737L77.7339 14.7386ZM66.6533 0.000271797L72.1958 7.82824L55.3093 14.765H46.9775L66.6533 0.000271797Z",
    fill: "url(#paint2_linear_1168_18957)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.0788 37.5779C53.1913 38.2992 53.3698 38.9933 53.6082 39.6546C54.5264 37.5221 56.0947 35.7145 58.0961 34.5321C58.078 33.571 58.1827 32.6263 58.3986 31.7211C56.5306 32.1616 54.7692 32.8403 53.1413 33.7227C52.9048 34.9599 52.8726 36.2601 53.0788 37.5779Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.192 27.9468C51.5669 28.0502 50.9529 28.1805 50.3498 28.3356C49.8312 30.0689 49.518 31.8836 49.4352 33.7431C51.793 32.2559 54.472 31.2079 57.3789 30.7352C57.8379 30.6596 58.2944 30.603 58.7509 30.5587C59.0633 29.7012 59.459 28.8881 59.9595 28.1354C57.4716 27.6066 54.8506 27.5181 52.192 27.9468Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.9655 30.5887L66.0957 28.5477L67.1555 30.5887H64.9655ZM66.9809 27.0808H65.3238L61.1573 34.6135H62.8684L64.3101 31.866H67.8664L69.2798 34.6135H71.2064L66.9809 27.0808Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.3782 24.841C59.8913 21.3376 55.2791 19.0705 50.2685 18.5857C48.6919 21.0376 47.5895 23.8131 47.0673 26.7607C47.9951 26.4742 48.9523 26.2465 49.9368 26.0859C53.6919 25.4738 57.3743 25.8926 60.7105 27.1328C61.4668 26.2344 62.3641 25.4573 63.3782 24.841Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.789 59.1621V62.7631H100.367V75.3534H96.7657V75.9997H101.009V63.4061H108.427V59.1621H107.789Z",
    fill: "#247636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.341 62.7631H89.1559V63.4062H95.341V62.7631Z",
    fill: "#247636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.013 64.9043L116.695 60.5135L114.25 64.9043H119.013ZM114.997 57.3634H118.64L127.92 73.5512H123.69L120.571 67.6457H112.814L109.604 73.5512H105.85L114.997 57.3634Z",
    fill: "#247636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2547 64.9043L10.9253 60.5135L8.44198 64.9043H13.2547ZM9.2313 57.3634H12.8698L22.15 73.5512H17.9174L14.8152 67.6457H7.00522L3.83947 73.5512H0.0804443L9.2313 57.3634Z",
    fill: "#247636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9 64.9043C36.4665 64.9043 36.8748 64.8097 37.1157 64.6246C37.3566 64.436 37.4763 64.139 37.4763 63.7205V62.1373C37.4763 61.7185 37.3566 61.4188 37.1157 61.2436C36.8748 61.0657 36.4665 60.9779 35.9 60.9779H27.4938V64.9043H35.9ZM23.7389 57.3634H37.6193C38.2319 57.3634 38.7154 57.3912 39.061 57.4575C39.4108 57.521 39.7378 57.6431 40.0463 57.8245C40.5037 58.0831 40.8185 58.4427 40.9893 58.8935C41.157 59.34 41.2442 60.0245 41.2442 60.9298V64.7852C41.2442 65.3371 41.2236 65.7634 41.1782 66.0565C41.1359 66.3574 41.0487 66.6395 40.9266 66.9159C40.6964 67.4394 40.3296 67.8066 39.8299 68.0158C39.3231 68.2221 38.5883 68.3266 37.6193 68.3266H27.4938V73.5512H23.7389V57.3634Z",
    fill: "#247636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1023 64.9043C57.6735 64.9043 58.0755 64.8097 58.3164 64.6246C58.5573 64.436 58.6791 64.139 58.6791 63.7205V62.1373C58.6791 61.7185 58.5573 61.4188 58.3164 61.2436C58.0755 61.0657 57.6735 60.9779 57.1023 60.9779H48.6993V64.9043H57.1023ZM44.9413 57.3634H58.8224C59.4368 57.3634 59.9191 57.3912 60.2634 57.4575C60.614 57.521 60.9396 57.6431 61.2462 57.8245C61.7107 58.0831 62.0167 58.4427 62.1925 58.8935C62.3641 59.34 62.4479 60.0245 62.4479 60.9298V64.7852C62.4479 65.3371 62.4268 65.7634 62.3852 66.0565C62.3396 66.3574 62.2519 66.6395 62.1265 66.9159C61.8979 67.4394 61.5325 67.8066 61.0298 68.0158C60.5268 68.2221 59.7931 68.3266 58.8224 68.3266H48.6993V73.5512H44.9413V57.3634Z",
    fill: "#247636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3182 69.9611V60.9779H69.5864V69.9611H81.3182ZM85.0721 69.9826C85.0721 70.6459 85.0094 71.2086 84.8843 71.6616C84.7688 72.1198 84.5661 72.4864 84.2812 72.7625C84.004 73.0452 83.6369 73.2476 83.1813 73.3699C82.7289 73.4923 82.1668 73.5512 81.503 73.5512H69.3703C68.7029 73.5512 68.1474 73.4923 67.7038 73.3699C67.2531 73.2476 66.8942 73.0452 66.6143 72.7625C66.3354 72.4864 66.1317 72.1198 66.0065 71.6616C65.8836 71.2086 65.8242 70.6459 65.8242 69.9826V60.9298C65.8242 59.6164 66.0871 58.6976 66.6143 58.1637C67.1384 57.6294 68.0569 57.3634 69.3703 57.3634H81.503C82.1668 57.3634 82.7289 57.4263 83.1813 57.5551C83.6369 57.6888 84.004 57.8876 84.2812 58.1637C84.5661 58.4359 84.7688 58.806 84.8843 59.2666C85.0094 59.7248 85.0721 60.2797 85.0721 60.9298V69.9826Z",
    fill: "#247636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.5557 73.5512H94.7732V60.9779H87.3519V57.3634H105.99V60.9779H98.5557V73.5512Z",
    fill: "#247636"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1168_18957",
    x1: 84.1226,
    y1: 30.7814,
    x2: 76.508,
    y2: 30.7814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55B336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E5029"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1168_18957",
    x1: 62.3687,
    y1: 12.2914,
    x2: 62.3687,
    y2: 46.0092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55B336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E5029"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1168_18957",
    x1: 46.9775,
    y1: 7.38247,
    x2: 77.7339,
    y2: 7.38247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55B336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E5029"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1168_18957"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 127.839,
    height: 76,
    fill: "white",
    transform: "translate(0.0804443)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppotaIcon);
export default __webpack_public_path__ + "static/media/appota-icon.48d1aca3c29268331036124b2ae923f9.svg";
export { ForwardRef as ReactComponent };